import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

import type { CsatEligibilityData } from './CsatEligibilityData';
import { STORAGE_KEY } from './STORAGE_KEY';

const DEFAULTS: CsatEligibilityData = {
	lastShownAt: 0,
	lastInteractedAt: 0,
	qualifyingConversations: 0,
};

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
	return typeof value === 'object' && value !== null && !Array.isArray(value);
};

const isCsatEligibilityData = (value: unknown): value is CsatEligibilityData => {
	return (
		isPlainObject(value) &&
		typeof value.lastShownAt === 'number' &&
		typeof value.lastInteractedAt === 'number' &&
		typeof value.qualifyingConversations === 'number'
	);
};

export const readFromStorage = (): CsatEligibilityData => {
	try {
		const raw = AtlBrowserStorageLocal.getItem(STORAGE_KEY);
		if (raw) {
			const parsed: unknown = JSON.parse(raw);
			if (isCsatEligibilityData(parsed)) {
				return parsed;
			}
		}
	} catch {
		// Storage unavailable or JSON corrupt — fall through to defaults.
	}
	return DEFAULTS;
};
